import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { EVENTS_CARD_TYPE, EVENTS_GAMEPLAY_STATUS } from '../constants';
var generateSingleGameCard = function generateSingleGameCard(eventsAssets) {
  return {
    BackgroundCard: eventsAssets.EVENTS_CARD_PURPLE,
    GlowCard: eventsAssets.EVENTS_CARD_FRAME_GLOW,
    BottomCard: eventsAssets.EVENTS_CARD_BOTTOM_PURPLE,
    BackgroundDetail: eventsAssets.EVENTS_DETAIL_CARD_PURPLE,
    EntriesCounterDetail: eventsAssets.EVENTS_DETAIL_COUNTER_PURPLE,
    Ribbon: eventsAssets.EVENTS_DEFAULT_RIBBON,
    PodiumBottom: eventsAssets.EVENTS_PODIUM_ACTIVE,
    StrokeColor: '#220d55',
    ProgressBarColorTheme: {
      barBackgroundColor: 'rgb(59, 0, 122)',
      barBorderColor: 'rgb(101, 40, 179)',
      barFillColor: ['rgb(194, 148, 241)', 'rgb(124, 58, 201)'],
      barFillBorderColor: ['rgb(165, 125, 192)', 'rgb(147, 76, 225)']
    }
  };
};
var generateMultipleGamesCard = function generateMultipleGamesCard(eventsAssets) {
  return {
    BackgroundCard: eventsAssets.EVENTS_CARD_MULTIlPLE_GAMES,
    GlowCard: eventsAssets.EVENTS_CARD_FRAME_GLOW,
    BottomCard: eventsAssets.EVENTS_CARD_BOTTOM_BLUE,
    Title: eventsAssets.EVENTS_MULTIPLE_GAMES_TITLE,
    BackgroundDetail: eventsAssets.EVENTS_DETAIL_CARD_BLUE,
    EntriesCounterDetail: eventsAssets.EVENTS_DETAIL_COUNTER_BLUE,
    Ribbon: eventsAssets.EVENTS_DEFAULT_RIBBON,
    PodiumBottom: eventsAssets.EVENTS_PODIUM_ACTIVE,
    StrokeColor: '#213787',
    ProgressBarColorTheme: {
      barBackgroundColor: 'rgb(4, 3, 105)',
      barBorderColor: 'rgb(0, 61, 140)',
      barFillColor: ['rgb(71, 197, 239)', 'rgb(28, 64, 149)'],
      barFillBorderColor: ['rgb(31, 167, 195)', 'rgb(58, 69, 161)']
    }
  };
};
var generateMultipleActivitiesCard = function generateMultipleActivitiesCard(eventsAssets) {
  return {
    BackgroundCard: eventsAssets.EVENTS_CARD_MULTIlPLE_ACTIVITIES,
    GlowCard: eventsAssets.EVENTS_CARD_FRAME_GLOW,
    BottomCard: eventsAssets.EVENTS_CARD_BOTTOM_PURPLE,
    Title: eventsAssets.EVENTS_MULTIPLE_ACTIVITIES_TITLE,
    BackgroundDetail: eventsAssets.EVENTS_DETAIL_CARD_PURPLE,
    EntriesCounterDetail: eventsAssets.EVENTS_DETAIL_COUNTER_PURPLE,
    Ribbon: eventsAssets.EVENTS_DEFAULT_RIBBON,
    PodiumBottom: eventsAssets.EVENTS_PODIUM_ACTIVE,
    StrokeColor: '#220d55',
    ProgressBarColorTheme: {
      barBackgroundColor: 'rgb(59, 0, 122)',
      barBorderColor: 'rgb(101, 40, 179)',
      barFillColor: ['rgb(194, 148, 241)', 'rgb(124, 58, 201)'],
      barFillBorderColor: ['rgb(165, 125, 192)', 'rgb(147, 76, 225)']
    }
  };
};
var generateTopBannerCard = function generateTopBannerCard(eventsAssets) {
  return {
    BackgroundCard: eventsAssets.EVENTS_CARD_ORANGE,
    GlowCard: eventsAssets.EVENTS_CARD_FRAME_GLOW_LIVE_OPS,
    BottomCard: eventsAssets.EVENTS_CARD_BOTTOM_ORANGE,
    BackgroundDetail: eventsAssets.EVENTS_DETAIL_CARD_ORANGE,
    EntriesCounterDetail: eventsAssets.EVENTS_DETAIL_COUNTER_ORANGE,
    Ribbon: eventsAssets.EVENTS_DEFAULT_RIBBON,
    PodiumBottom: eventsAssets.EVENTS_PODIUM_ACTIVE,
    TopBanner: eventsAssets.EVENTS_CARD_IMAGE_LIVE_OPS,
    StrokeColor: '#a44038',
    ProgressBarColorTheme: {
      barBackgroundColor: 'rgb(171, 73, 0)',
      barBorderColor: 'rgb(255, 88, 5)',
      barFillColor: ['rgb(255, 179, 60)', 'rgb(255, 102, 18)'],
      barFillBorderColor: ['rgb(250, 227, 146)', 'rgb(255, 119, 49)']
    }
  };
};
var generateAllGamesCard = function generateAllGamesCard(eventsAssets) {
  return {
    BackgroundCard: eventsAssets.EVENTS_CARD_ALL_GAMES,
    GlowCard: eventsAssets.EVENTS_CARD_FRAME_GLOW,
    BottomCard: eventsAssets.EVENTS_CARD_BOTTOM_PINK,
    Title: eventsAssets.EVENTS_ALL_GAMES_TITLE,
    BackgroundDetail: eventsAssets.EVENTS_DETAIL_CARD_PINK,
    EntriesCounterDetail: eventsAssets.EVENTS_DETAIL_COUNTER_PINK,
    Ribbon: eventsAssets.EVENTS_DEFAULT_RIBBON,
    PodiumBottom: eventsAssets.EVENTS_PODIUM_ACTIVE,
    StrokeColor: '#732c5d',
    ProgressBarColorTheme: {
      barBackgroundColor: 'rgb(125, 0, 63)',
      barBorderColor: 'rgb(173, 0, 87)',
      barFillColor: ['rgb(255, 136, 183)', 'rgb(235, 28, 130)'],
      barFillBorderColor: ['rgb(228, 79, 138)', 'rgb(255, 164, 212)']
    }
  };
};
var generateTitleCard = function generateTitleCard(cardType, eventsAssets) {
  return _defineProperty(_defineProperty(_defineProperty({}, EVENTS_CARD_TYPE.MULTIPLE_GAMES, eventsAssets.EVENTS_MULTIPLE_GAMES_TITLE), EVENTS_CARD_TYPE.MULTIPLE_ACTIVITIES, eventsAssets.EVENTS_MULTIPLE_ACTIVITIES_TITLE), EVENTS_CARD_TYPE.ALL_GAMES, eventsAssets.EVENTS_ALL_GAMES_TITLE)[cardType] || null;
};
var generateMainEventCard = function generateMainEventCard(cardType, eventsAssets) {
  return _objectSpread(_objectSpread({
    Title: generateTitleCard(cardType, eventsAssets)
  }, cardType === EVENTS_CARD_TYPE.SINGLE_GAME && {
    BackgroundCard: eventsAssets.EVENTS_CARD_BLUE,
    GlowCard: eventsAssets.EVENTS_CARD_FRAME_GLOW,
    BottomCard: eventsAssets.EVENTS_CARD_BOTTOM_BLUE,
    BackgroundDetail: eventsAssets.EVENTS_DETAIL_CARD_BLUE,
    EntriesCounterDetail: eventsAssets.EVENTS_DETAIL_COUNTER_BLUE,
    ProgressBarColorTheme: {
      barBackgroundColor: 'rgb(4, 3, 105)',
      barBorderColor: 'rgb(0, 61, 140)',
      barFillColor: ['rgb(71, 197, 239)', 'rgb(28, 64, 149)'],
      barFillBorderColor: ['rgb(31, 167, 195)', 'rgb(58, 69, 161)']
    }
  }), {}, {
    Ribbon: {
      Title: eventsAssets.EVENTS_MAIN_RIBBON_TITLE,
      Crown: eventsAssets.EVENTS_MAIN_RIBBON_CROWN,
      Trombone: eventsAssets.EVENTS_MAIN_RIBBON_TROMBONE
    },
    PodiumBottom: eventsAssets.EVENTS_PODIUM_ACTIVE,
    PodiumLightBottom: eventsAssets.EVENTS_PODIUM_LIGHT,
    StrokeColor: '#213787'
  });
};
var generateEndedCard = function generateEndedCard(isMainEvent, eventsAssets, totalEntriesAvailable) {
  return {
    ShadowCard: eventsAssets.EVENTS_CARD_FRAME_SHADOW,
    BackgroundDetail: eventsAssets.EVENTS_DETAIL_CARD_GREY,
    EntriesCounterDetail: eventsAssets.EVENTS_DETAIL_COUNTER_GREY,
    ProgressBarColorTheme: {
      barBackgroundColor: 'rgb(46, 45, 51)',
      barBorderColor: 'rgb(46, 45, 51)',
      barFillColor: ['rgb(139, 139, 139)', 'rgb(68, 68, 68)'],
      barFillBorderColor: ['rgb(116, 116, 116)', 'rgb(116, 116, 116)']
    },
    Ribbon: isMainEvent ? {
      Title: eventsAssets.EVENTS_MAIN_RIBBON_TITLE_SHADOW,
      Crown: eventsAssets.EVENTS_MAIN_RIBBON_CROWN_SHADOW,
      Trombone: eventsAssets.EVENTS_MAIN_RIBBON_TROMBONE_SHADOW
    } : eventsAssets.EVENTS_DEFAULT_RIBBON_SHADOW,
    PodiumBottom: eventsAssets.EVENTS_PODIUM_DISABLED,
    PodiumLightBottom: null
  };
};
var generateEventsCardDataRendering = function generateEventsCardDataRendering(_ref, eventsAssets) {
  var isMainEvent = _ref.isMainEvent,
    cardType = _ref.cardType,
    eventGameplayStatus = _ref.eventGameplayStatus,
    totalEntriesAvailable = _ref.totalEntriesAvailable;
  var generateCard = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, EVENTS_CARD_TYPE.SINGLE_GAME, generateSingleGameCard(eventsAssets)), EVENTS_CARD_TYPE.MULTIPLE_GAMES, generateMultipleGamesCard(eventsAssets)), EVENTS_CARD_TYPE.MULTIPLE_ACTIVITIES, generateMultipleActivitiesCard(eventsAssets)), EVENTS_CARD_TYPE.TOP_BANNER, generateTopBannerCard(eventsAssets)), EVENTS_CARD_TYPE.ALL_GAMES, generateAllGamesCard(eventsAssets))[cardType];
  if (isMainEvent) generateCard = _objectSpread(_objectSpread({}, generateCard), generateMainEventCard(cardType, eventsAssets));
  if (eventGameplayStatus !== EVENTS_GAMEPLAY_STATUS.RUNNING) generateCard = _objectSpread(_objectSpread({}, generateCard), generateEndedCard(isMainEvent, eventsAssets, totalEntriesAvailable));
  return generateCard;
};
export default generateEventsCardDataRendering;